import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "interlocuteur-table"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "item-role" }
const _hoisted_10 = { class: "item-name" }
const _hoisted_11 = { class: "item-phone" }
const _hoisted_12 = { class: "item-email" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  class: "notFoundTd",
  colspan: "5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_content_loader = _resolveComponent("content-loader")!
  const _component_RadioBox = _resolveComponent("RadioBox")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_content_loader, {
          width: _ctx.width,
          height: "150"
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createElementVNode("circle", {
              cx: "50",
              cy: "60",
              r: "11"
            }, null, -1),
            _createElementVNode("rect", {
              x: "78",
              y: "32",
              rx: "4",
              ry: "4",
              width: "3500",
              height: "52"
            }, null, -1),
            _createElementVNode("circle", {
              cx: "50",
              cy: "122",
              r: "11"
            }, null, -1),
            _createElementVNode("rect", {
              x: "78",
              y: "96",
              rx: "4",
              ry: "4",
              width: "3500",
              height: "52"
            }, null, -1)
          ]))]),
          _: 1
        }, 8, ["width"])
      ]))
    : (_openBlock(), _createElementBlock("table", _hoisted_2, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _cache[3] || (_cache[3] = _createElementVNode("th", null, null, -1)),
            _createElementVNode("th", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('contact.page.contact.select.table.role')), 1),
              _createElementVNode("div", {
                class: "sortIcons",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doSortRole()))
              }, [
                (this.isSortUp(_ctx.sortRole))
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.sortUpIcon,
                      alt: "sort up icon",
                      class: "pointer"
                    }, null, 8, _hoisted_3))
                  : _createCommentVNode("", true),
                (this.isSortDown(_ctx.sortRole))
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _ctx.sortDownIcon,
                      alt: "sort down icon",
                      class: "pointer"
                    }, null, 8, _hoisted_4))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("th", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('contact.page.contact.select.table.name')), 1),
              _createElementVNode("div", {
                class: "sortIcons",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doSortNom()))
              }, [
                (this.isSortUp(_ctx.sortNom))
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.sortUpIcon,
                      alt: "sort up icon",
                      class: "pointer"
                    }, null, 8, _hoisted_5))
                  : _createCommentVNode("", true),
                (this.isSortDown(_ctx.sortNom))
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _ctx.sortDownIcon,
                      alt: "sort down icon",
                      class: "pointer"
                    }, null, 8, _hoisted_6))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("th", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('contact.page.contact.select.table.phone')), 1)
            ]),
            _createElementVNode("th", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('contact.page.contact.select.table.email')), 1)
            ])
          ])
        ]),
        (_ctx.interlocuteurs.length > 0)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.interlocuteurs, (interlocuteur) => {
                return (_openBlock(), _createElementBlock("tr", {
                  onClick: ($event: any) => (_ctx.toggleSelect(interlocuteur)),
                  key: interlocuteur.id
                }, [
                  _createElementVNode("td", null, [
                    _createVNode(_component_RadioBox, {
                      class: "radio",
                      selected: interlocuteur.id === _ctx.selectedInterlocuteur?.id
                    }, null, 8, ["selected"])
                  ]),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.formatRoles(interlocuteur)), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.formatName(interlocuteur)), 1),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(interlocuteur.telephone), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(interlocuteur.email), 1)
                ], 8, _hoisted_8))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("tbody", _hoisted_13, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.$t('contact.page.contact.select.table.noresult')), 1)
              ])
            ]))
      ]))
}